import React from 'react';
import { ISmartProps, KIND as IKind } from './types';
import { View } from './view';
import { overrides as customOverrides } from './overrides';
import { mergeOverrides } from 'baseui';

export type FeedbackProps = Omit<ISmartProps, 'css'>;
export type KIND = IKind;

export const Feedback = React.forwardRef((props: FeedbackProps, ref: any) => {
	return <View {...props} ref={ref} />;
});

export const feedbackOverrides = (props: any, kind: string, overrides: any) => mergeOverrides(customOverrides({ ...props, kind: kind, phantom: props.phantom }), overrides)

export { toaster, ToasterContainer } from 'baseui/toast';
